import type { RxJsonSchema } from 'rxdb';
import type { RiskAssessments } from './riskAssessment.types';

export const riskAssessmentSchema: RxJsonSchema<RiskAssessments> = {
  type: 'object',
  version: 1,
  description: 'describes deficiency lists',
  primaryKey: 'pkComponentRiskUUID',
  properties: {
    pkComponentRiskUUID: { type: 'string', maxLength: 36 },
    componentRiskResultId: { type: ['string', 'null'] },
    fkDeficiencyUUID: { type: ['string', 'null'] },
    fkComponentFailure: { type: ['string', 'null'] },
    componentRiskCategoryRankType: { type: ['number', 'null'] },
    riskType: { type: ['number', 'null'] },
    riskValue: { type: ['number', 'null'] },
    assetID: { type: ['number', 'null'] },
    riskName: { type: ['string', 'null'] },
    name: { type: ['string', 'null'] },
    inspectionId: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    fkInspectorField: { type: ['number', 'null'] },
    fkInspectorLead: { type: ['number', 'null'] },
    siteId: { type: ['number', 'null'] },
    disciplineId: { type: ['number', 'null'] },
    activeDeficiencyInspectionId: { type: ['number', 'null'] },
  },
};
